var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'dateComponent':true,
  'form-input': true,
  'form-input--required': _vm.data.required
  }},[_c('label',[_vm._v(_vm._s(_vm.data.caption)+": "),(_vm.data.visibility)?_c('img',{staticClass:"mx-1",attrs:{"width":"15","src":require("@/assets/images/eye.svg"),"alt":"view"}}):_vm._e()]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.componentValue),expression:"componentValue"}],attrs:{"disabled":_vm.viewOnly,"type":"date"},domProps:{"value":(_vm.componentValue)},on:{"change":_vm.emitChange,"input":function($event){if($event.target.composing)return;_vm.componentValue=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }